var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[(_vm.items && _vm.items.length)?_c('nav',{attrs:{"id":"footer-menu"}},[_c('tree-menu',{attrs:{"items":_vm.items,"max-depth":1,"allow-multiple-active-items":true,"delay":100}})],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }